/** @format */

import React, { useEffect, useState } from 'react'
import { getData } from '../../../../Helpers/webApi'
import BreadCrumb from '../../../../Components/BreadCrumb/Index'
import Loader from '../../../../Components/Loaders/Loader'
import AddNewButton from '../../../../Components/Buttons/AddNewButton/AddNewButton'
import Pager from '../../../../Components/Tables/Pager'
import localize from '../../../../Global/Localize'
import SimpleTable from '../../../../Components/Tables/SimpleTable'
import { formatCurrency, formatDate } from '../../../../Helpers/formatters'
import EnumsServerCombo from '../../../../Components/ComboBox/EnumsServerCombo'
import { TellerType } from '../../../../Helpers/constants'
import TellersModal from './TellersModal'

function Tellers() {
  const [tableData, setTableData] = useState([])
  const [isBusy, setIsBusy] = useState(false)
  const [search, setSearch] = useState('')

  const [sortedBy, setSortedBy] = useState(null)
  const [selectedTeller, setSelectedTeller] = useState(null)

  const [reqParams, setReqParams] = useState({
    text: '',
    tellerType: TellerType.EMPLOYEE,
    pageIndex: 0,
    pageSize: 10,
  })
  const [tableMeta, setTableMeta] = useState({ ...reqParams, itemsCount: 0 })
  const [mode, setMode] = useState(null)
  const [refreshAt, setRefreshAt] = useState(null)
  useEffect(() => {
    loadTableData()
  }, [reqParams, refreshAt])

  const columns = [
    { label: localize('paddedCode'), template: r => <>{r.paddedCode}</> },
    {
      label: localize('typeDescription'),
      template: r => <>{r.typeDescription}</>,
    },
    { label: localize('description'), template: r => <>{r.description}</> },
    {
      label: localize('rangeLowerLimit'),
      template: r => <>{formatCurrency(r.rangeLowerLimit)}</>,
    },
    {
      label: localize('rangeUpperLimit'),
      template: r => <>{formatCurrency(r.rangeUpperLimit)}</>,
    },
    {
      label: localize('miniStatementItemsCap'),
      template: r => <>{r.miniStatementItemsCap}</>,
    },
    {
      label: localize('chartOfAccountName'),
      template: r => <>{r.chartOfAccountName}</>,
    },
    {
      label: localize('chartOfAccountCostDistributionRuleDescription'),
      template: r => <>{r.chartOfAccountCostDistributionRuleDescription}</>,
    },
    {
      label: localize('shortageChartOfAccountName'),
      template: r => <>{r.shortageChartOfAccountName}</>,
    },
    {
      label: localize('shortageChartOfAccountCostDistributionRuleDescription'),
      template: r => (
        <>{r.shortageChartOfAccountCostDistributionRuleDescription}</>
      ),
    },
    {
      label: localize('excessChartOfAccountName'),
      template: r => <>{r.excessChartOfAccountName}</>,
    },
    {
      label: localize('excessChartOfAccountCostDistributionRuleDescription'),
      template: r => (
        <>{r.excessChartOfAccountCostDistributionRuleDescription}</>
      ),
    },
    {
      label: localize('employeeCustomerFullName'),
      template: r => <>{r.employeeCustomerFullName}</>,
    },
    {
      label: localize('employeeBranchDescription'),
      template: r => <>{r.employeeBranchDescription}</>,
    },
    {
      label: localize('pointOfSaleAgencyDescription'),
      template: r => <>{r.pointOfSaleAgencyDescription}</>,
    },
    { label: localize('reference'), template: r => <>{r.reference}</> },
    {
      label: localize('isLocked'),
      template: r => (
        <span className="text-capitalize">{r.isLocked.toString()}</span>
      ),
    },
    {
      label: localize('createdDate'),
      template: r => <>{formatDate(r.createdDate)}</>,
    },
  ]

  async function loadTableData() {
    setIsBusy(true)
    const { success, data } = await getData(
      '/Teller/find-tellers-by-filter-in-page',
      reqParams,
      false
    )
    if (success) {
      setIsBusy(false)
      setTableData(data.pageCollection || [])
      setTableMeta({ ...reqParams, itemsCount: data.itemsCount })
    } else {
      setIsBusy(false)
    }
  }

  function handleSort(column, columnIndex) {
    if (!sortedBy) {
      let sorted = tableData.sort((a, b) => a[column] > b[column])
      setTableData([])
      setTimeout(() => {
        setTableData(sorted)
        setSortedBy([column, 1, columnIndex])
      }, 10)
    } else {
      let sorted = []
      if (sortedBy[1] === 0) {
        sorted = tableData.sort((a, b) => a[column] > b[column])
        setSortedBy([column, 1, columnIndex])
      } else {
        sorted = tableData.sort((a, b) => a[column] < b[column])
        setSortedBy([column, 0, columnIndex])
      }
      setTableData([])
      setTimeout(() => {
        setTableData(sorted)
      }, 10)
    }
    // setTableData(sorted)
  }

  const handleOnEdit = r => {
    setSelectedTeller({ ...r })
    setMode('edit')
  }

  const handleOnAdd = async r => {
    setSelectedTeller({ type: TellerType.EMPLOYEE })
    setMode('add')
  }

  return (
    <>
      <BreadCrumb
        tree={[localize('frontOfficeManagement'), localize('teller')]}
      />
      <div className="row">
        <div className="col-12">
          <div className="card bg-white">
            <div className="card-body">
              {isBusy ? (
                <Loader />
              ) : (
                <>
                  <div className="row mb-2">
                    <div className="col-md-4 gap-2">
                      <div className="mb-3">
                        <AddNewButton handleClickAddButton={handleOnAdd} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="d-flex align-items-center col-3">
                      <label
                        htmlFor="recordsPerPage"
                        className="text-capitalize"
                        style={{ marginLeft: -10 }}
                      >
                        {localize('recordsPerPage')}
                      </label>
                      <select
                        name=""
                        id="recordsPerPage"
                        className="form-select ms-3"
                        style={{ maxWidth: 60 }}
                        defaultValue={reqParams.pageSize}
                        onChange={e => {
                          setReqParams({
                            ...reqParams,
                            pageIndex: 0,
                            pageSize: e.target.value,
                          })
                        }}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                    <div className="col-3"></div>
                    <div className="col-3">
                      <div className="col d-flex align-items-center">
                        <label
                          className="text-capitalize me-1"
                          htmlFor="searchTable"
                        >
                          {localize('search')}
                        </label>
                        <EnumsServerCombo
                          customContainerStyle={{ width: '100%' }}
                          enumsKey="TellerType"
                          value={reqParams?.tellerType}
                          onChange={e => {
                            setReqParams({
                              ...reqParams,
                              tellerType: e.value,
                            })
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <form
                        className="col d-flex align-items-center"
                        onSubmit={e => {
                          e.preventDefault()
                          setReqParams({
                            ...reqParams,
                            text: search,
                            pageIndex: 0,
                          })
                        }}
                      >
                        <input
                          type="search"
                          id="searchTable"
                          className="form-control ms-2"
                          defaultValue={reqParams.text}
                          onChange={e => setSearch(e.target.value)}
                        ></input>
                        <button
                          type="button"
                          className="btn btn-primary ms-1"
                          onClick={() => {
                            setReqParams({
                              ...reqParams,
                              text: search,
                              pageIndex: 0,
                            })
                          }}
                        >
                          <i className="uil uil-filter"></i>
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="row col-12 mt-2">
                    <SimpleTable
                      contextMenu={e => (
                        <>
                          <div
                            onClick={() => {
                              handleOnEdit(e)
                            }}
                            className="ctxt-menu-item"
                          >
                            <i className="uil uil-edit"></i>
                            {localize('edit')}
                          </div>
                        </>
                      )}
                      data={tableData}
                      columns={columns}
                      onSort={(c, i) => handleSort(c, i)}
                      sortedBy={sortedBy}
                    />
                  </div>
                  <div className="row col-12 mt-2">
                    <Pager
                      {...tableMeta}
                      onPageChange={p =>
                        setReqParams({ ...reqParams, pageIndex: p })
                      }
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <TellersModal
        mode={mode}
        onHideModal={() => {
          setMode(null)
        }}
        setSelectedTeller={setSelectedTeller}
        selectedTeller={selectedTeller}
        onSetMode={m => setMode(m)}
        onUpdateRefreshAt={() => {
          setRefreshAt(!refreshAt)
        }}
      />
    </>
  )
}

export default Tellers
